import BuilderSideMenuSettings from 'pages/Components/BuilderSideMenuSettings'
import { PDFFillerContext } from 'pages/Contexts/PdfFillerContext'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import Space from 'ui/atoms/Space'

import { SidebarProps, SidePanel } from '@/ui/atoms/SidePanel'
import cn from '@/utils/tailwind/cn'

import AddInputPanel from './AddInputPanel'
import InputSettingsPanel from './InputSettingsPanel'
import SettingsPanel from './SettingsPanel'
import ZoomControl from './ZoomControl'

export const Sidebar = ({ className, ...props }: SidebarProps) => {
  const history = useHistory()
  const isDesignPage = history.location.pathname.includes('design')

  const { selectedInputFieldId, viewMode, settingsOpen } =
    React.useContext(PDFFillerContext)

  const renderSidePanelContent = React.useCallback(() => {
    if (settingsOpen) {
      return <SettingsPanel />
    }

    if (viewMode === 'edit') {
      return (
        <>
          <AddInputPanel />
          {Boolean(selectedInputFieldId) && <InputSettingsPanel />}
        </>
      )
    }

    return null
  }, [selectedInputFieldId, settingsOpen, viewMode])

  const isSettingsPage = history.location.pathname.includes('settings')

  if (isDesignPage) return null
  return (
    <SidePanel
      className={cn(
        'relative min-h-screen !overflow-visible',
        !isSettingsPage && '!p-4',
        className
      )}
      {...props}
    >
      {isSettingsPage ? (
        <BuilderSideMenuSettings
          negativeMargin={false}
          resourceType="document"
        />
      ) : (
        <Space size="large">
          <ZoomControl />
          {renderSidePanelContent()}
        </Space>
      )}
    </SidePanel>
  )
}
